export default __webpack_public_path__ + "static/media/action-button-in-panel-header.3bac59ac.png";